<template>
  <div>
    <v-layout mb-3 align-center row justify-start fill-height>
      <v-flex xs12 sm12 md12>
        <v-card flat>
          <v-layout row wrap>
            <v-flex
              xs3 sm3 md3
            >
              <v-card>
                <a :href="$store.getters.getPdf.url" target="_blank">
                  <v-flex>
                    <v-flex ml-4 pl-3>
                      <v-img
                        class="pointer ml-5"
                        :src="require('@/assets/pdf_file_image.png')"
                        height="100px"
                        width="100px"
                      >
                      </v-img>
                    </v-flex>
                    <v-layout align-center row justify-center fill-height v-if="$store.getters.getPdfFile">
                      {{ $store.getters.getPdfFile.name }}
                    </v-layout>
                    <v-layout align-center row justify-center fill-height v-else>
                      {{ $store.getters.getPdf.id}}
                    </v-layout>
                  </v-flex>
                </a>
                <v-card-actions>
                  <v-layout align-center row justify-center fill-height>
                    <img class="pointer" @click="closePdf"
                         :src="require('@/assets/baseline-clear-24px.svg')">
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: "AddOrderCommercialInvoiceView",
    methods: {
      /**
       * Set event to close pdf file (remove event)
       */
      closePdf() {
        this.$store.dispatch('setEventForAddOrder', 'close')
      }
    }
  }
</script>

<style scoped lang="stylus">
  a
    color black
</style>
